export default __webpack_public_path__ + "static/drop-a-hint-desktop-7496fd91ac55a9c700b8eb2b7aba3499.jpg";